import s from "./style.module.scss";

interface ProgressLineProps {
  text?: string;
  width?: string;
}

export const ProgressLine = ({ text, width }: ProgressLineProps) => {
  return (
    <div className={`${s.progress} ${s.progressStriped} ${s.active}`}>
      <div
        role="progressbar"
        style={{ width }}
        className={`${s.progressBar} ${s.progressBarDanger}`}
      >
        <span>{text}</span>
      </div>
    </div>
  );
};
